import React from 'react'
import { Helmet } from 'react-helmet';
import Sidenavigation from '../Layouts/Sidenavigation';
import Topnavigation from '../Layouts/Topnavigation';
import Content from '../../CommonFolders/Helpdesk-Work-Hours-Report/Content'

export default function HelpdeskCWorkHours(){
    return(
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Customer Helpdesk Work Hrs Report</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content Page='Management' TypeOfUser='Helpdesk C' />
                {/* page content end  */}

            </main>

        </div>
    )
}